import React, { useMemo, useState, useCallback } from 'react';
import t from '~t';
import _ from 'lodash';
import config from '~config';
import { useSelector } from 'react-redux';
import { isPro } from '~data/selectors/user';

import Pic from './pic.svg?component';
import UserUpgrade from '~co/user/upgrade';

export default function Upgrade() {
  const [show, setShow] = useState(false);
  const onShowClick = useCallback(
    (e) => {
      e.preventDefault();
      setShow(true);
    },
    [setShow],
  );

  const pro = useSelector(isPro);

  const message = useMemo(() => {
    if (_.random(0, 1) == 1) return t.s('proFeaturesList');
    return t.s('proGreeting');
  }, []);

  if (pro) return null;

  return (
    <>
      <a
        href={config.links.pro.buy}
        onClick={onShowClick}
        className='ui-banner relative z-[1] flex items-center overflow-hidden px-[var(--padding-medium)] py-[calc(var(--padding-small)+var(--padding-mini))] text-[length:var(--secondary-font-size)] shadow-[0_calc(var(--shadow-height)*-1)_0_var(--shadow-color)]'
      >
        <span className='mr-[85px] block flex-1'>
          <span className='block font-semibold [html.mobile_&]:hidden'>
            {message}
          </span>
          {t.s('upgradeToPro')}
        </span>

        <Pic className='absolute right-4 rotate-[15deg]' />
      </a>

      {show ? <UserUpgrade onClose={() => setShow(false)} /> : null}
    </>
  );
}
